<template>
  <div>
    <div v-if="loading" class="blog-header">
      <div class="author">
        <b-skeleton type="avatar" width="45px" height="45px"></b-skeleton>
        <div class="author-details">
          <div class="author-name">
            <b-skeleton
              animation="wave"
              width="70px"
              height="18px"
            ></b-skeleton>
            <b-skeleton
              class="ml-3"
              type="button"
              height="22px"
              width="55px"
            ></b-skeleton>
          </div>
          <span class="details">
            <b-skeleton
              class="mt-2"
              animation="wave"
              width="70px"
              height="10px"
            ></b-skeleton>
          </span>
        </div>
      </div>
      <div class="social-sharing">
        <b-skeleton type="avatar"></b-skeleton>
        <b-skeleton type="avatar"></b-skeleton>
        <b-skeleton type="avatar"></b-skeleton>
        <b-skeleton type="avatar"></b-skeleton>
      </div>
    </div>
    <div v-else class="blog-header">
      <div class="author">
        <img
          v-if="blog.blogger && blog.blogger.imgURL"
          @click="handleBloggerProfileClick"
          :src="blog.blogger.imgURL"
          alt=""
        />
        <div class="author-details">
          <div class="author-name">
            <h3
              v-if="blog.blogger && blog.blogger.firstname"
              @click="handleBloggerProfileClick"
            >
              {{ blog.blogger.firstname + " " + blog.blogger.lastname }}
            </h3>
            <button
              class="btn btn-follow"
              :class="isFollowed ? 'followed' : ''"
              @click="$emit('followClicked')"
            >
              <span v-if="!isFollowed">Follow</span>
              <span v-else>Following</span>
            </button>
          </div>
          <span class="details" v-if="blog.blog && blog._published_at">
            {{ getDate(blog._published_at.toDate()) }} ∙
            {{ blog.blog.mins }} Min Read
          </span>
        </div>
      </div>
      <div class="social-sharing">
        <span class="ico" @click="shareToFacebook(blog.slug)">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.1173 0H0.882667C0.395333 0 0 0.395333 0 0.882667V15.1173C0 15.6053 0.395333 16 0.882667 16H8.54533V9.804H6.45933V7.39H8.54533V5.60667C8.54533 3.54067 9.808 2.41667 11.6513 2.41667C12.5347 2.41667 13.294 2.48133 13.5153 2.51067V4.67067H12.2347C11.2347 4.67067 11.04 5.15133 11.04 5.85133V7.392H13.4293L13.1193 9.812H11.04V16H15.1167C15.6053 16 16 15.6053 16 15.1173V0.882667C16 0.395333 15.6053 0 15.1173 0Z"
              fill="#B3C2CB"
            />
          </svg>
        </span>
        <span class="ico" @click="shareToTwitter(blog.slug)">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0)">
              <path
                d="M14.2857 -0.0183105H1.71429C0.767857 -0.0183105 0 0.751546 0 1.70044V14.3046C0 15.2535 0.767857 16.0234 1.71429 16.0234H14.2857C15.2321 16.0234 16 15.2535 16 14.3046V1.70044C16 0.751546 15.2321 -0.0183105 14.2857 -0.0183105ZM12.5393 5.66789C12.5464 5.76815 12.5464 5.87199 12.5464 5.97225C12.5464 9.07674 10.1893 12.6539 5.88214 12.6539C4.55357 12.6539 3.32143 12.2672 2.28571 11.6012C2.475 11.6226 2.65714 11.6298 2.85 11.6298C3.94643 11.6298 4.95357 11.2574 5.75714 10.6272C4.72857 10.6057 3.86429 9.92895 3.56786 8.99796C3.92857 9.05168 4.25357 9.05168 4.625 8.955C3.55357 8.73657 2.75 7.79126 2.75 6.64901V6.62036C3.06071 6.79582 3.425 6.90324 3.80714 6.91756C3.48587 6.7033 3.22249 6.41263 3.04053 6.07149C2.85856 5.73035 2.76365 5.34935 2.76429 4.96248C2.76429 4.52563 2.87857 4.12459 3.08214 3.77726C4.23571 5.20239 5.96786 6.13338 7.91071 6.23364C7.57857 4.64022 8.76786 3.34757 10.1964 3.34757C10.8714 3.34757 11.4786 3.63045 11.9071 4.08879C12.4357 3.98852 12.9429 3.79158 13.3929 3.52303C13.2179 4.0673 12.85 4.52563 12.3643 4.81567C12.8357 4.76554 13.2929 4.63306 13.7143 4.45044C13.3964 4.91951 12.9964 5.33488 12.5393 5.66789Z"
                fill="#B3C2CB"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </span>
        <span class="ico" @click="shareToLinkedin(blog.slug)">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.6313 13.6347H11.262V9.922C11.262 9.03667 11.244 7.89733 10.0273 7.89733C8.792 7.89733 8.60333 8.86067 8.60333 9.85667V13.6347H6.234V6H8.51V7.04067H8.54067C8.85867 6.44067 9.632 5.80733 10.7873 5.80733C13.188 5.80733 13.632 7.38733 13.632 9.444V13.6347H13.6313ZM3.558 4.95533C2.79533 4.95533 2.18267 4.338 2.18267 3.57867C2.18267 2.82 2.796 2.20333 3.558 2.20333C4.318 2.20333 4.934 2.82 4.934 3.57867C4.934 4.338 4.31733 4.95533 3.558 4.95533ZM4.746 13.6347H2.37V6H4.746V13.6347ZM14.8167 0H1.18067C0.528 0 0 0.516 0 1.15267V14.8473C0 15.4847 0.528 16 1.18067 16H14.8147C15.4667 16 16 15.4847 16 14.8473V1.15267C16 0.516 15.4667 0 14.8147 0H14.8167Z"
              fill="#B3C2CB"
            />
          </svg>
        </span>
        <span
          class="ico"
          v-b-popover.top.hover="popupText"
          @click="copytoClipboard(blog.slug)"
          @mouseleave="changePopupText"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.33301 6.66659C6.96482 6.66659 6.66634 6.96506 6.66634 7.33325V13.3333C6.66634 13.7014 6.96482 13.9999 7.33301 13.9999H13.333C13.7012 13.9999 13.9997 13.7014 13.9997 13.3333V7.33325C13.9997 6.96506 13.7012 6.66659 13.333 6.66659H7.33301ZM5.33301 7.33325C5.33301 6.22868 6.22844 5.33325 7.33301 5.33325H13.333C14.4376 5.33325 15.333 6.22868 15.333 7.33325V13.3333C15.333 14.4378 14.4376 15.3333 13.333 15.3333H7.33301C6.22844 15.3333 5.33301 14.4378 5.33301 13.3333V7.33325Z"
              fill="#A1B1BA"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M2.66699 2.00008C2.49018 2.00008 2.32061 2.07032 2.19559 2.19534C2.07056 2.32037 2.00033 2.48994 2.00033 2.66675V8.66675C2.00033 8.84356 2.07056 9.01313 2.19559 9.13815C2.32061 9.26318 2.49018 9.33342 2.66699 9.33342H3.33366C3.70185 9.33342 4.00033 9.63189 4.00033 10.0001C4.00033 10.3683 3.70185 10.6667 3.33366 10.6667H2.66699C2.13656 10.6667 1.62785 10.456 1.25278 10.081C0.877706 9.70589 0.666992 9.19718 0.666992 8.66675V2.66675C0.666992 2.13632 0.877706 1.62761 1.25278 1.25253C1.62785 0.877462 2.13656 0.666748 2.66699 0.666748H8.66699C9.19743 0.666748 9.70613 0.877462 10.0812 1.25253C10.4563 1.62761 10.667 2.13631 10.667 2.66675V3.33341C10.667 3.7016 10.3685 4.00008 10.0003 4.00008C9.63214 4.00008 9.33366 3.7016 9.33366 3.33341V2.66675C9.33366 2.48994 9.26342 2.32037 9.1384 2.19534C9.01337 2.07032 8.8438 2.00008 8.66699 2.00008H2.66699Z"
              fill="#A1B1BA"
            />
          </svg>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Share from "@/mixins/Share.js";
export default {
  name: "BlogHeader",
  props: ["loading", "blog", "isFollowed"],
  data() {
    return {};
  },
  mixins: [Share],
  computed: {
    blogger() {
      return this.blog.blogger;
    }
  },
  methods: {
    getDate(date) {
      return moment(date).format("DD MMMM");
    },
    handleBloggerProfileClick() {
      this.$router.push(`/blog/crew/@${this.blogger.profileName}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.blog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .author {
    display: grid;
    grid-template-columns: 48px 1fr;
    grid-column-gap: 16px;
    img {
      cursor: pointer;
      height: 48px;
      width: 48px;
      border-radius: 50%;
      object-fit: cover;
    }
    .author-details {
      .author-name {
        cursor: pointer;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 4px;
        h3 {
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          line-height: 26px;
          color: #474d52;
          margin-bottom: 0;
          margin-right: 12px;
        }
        .btn-follow {
          border: 1px solid #474d52;
          box-sizing: border-box;
          border-radius: 4px;
          width: 54px;
          height: 20px;
          padding: 0px;
          font-style: normal;
          font-weight: normal;
          font-size: 10px;
          line-height: 14px;
          transition: 0.2s ease;
          &:hover {
            background-color: #474d52;
            color: #fff;
            &:after,
            &:before {
              content: none;
            }
          }
        }
        .followed {
          width: 65px;
          color: #fff;
          background: #474d52;
        }
      }
      .details {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        color: #8d99a0;
      }
    }
  }

  .social-sharing {
    width: 176px;
    display: grid;
    grid-template-columns: 32px 32px 32px 32px;
    grid-column-gap: 16px;
    .ico {
      cursor: pointer;
      background: rgba(179, 194, 203, 0.1);
      height: 32px;
      width: 32px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      &:hover {
        background: rgba(179, 194, 203, 0.3);
      }
    }
  }
  .social-sharing-skeletons {
    display: flex;
  }
}
</style>
